import { Button } from '~/components/ui/Button';
import { WrapperWidget } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';
import { formatDate } from '~/helper/formatDate';
import { AppLink } from '~/components/AppLink';

interface Props {
  readonly contractUrl?: string;
  // timestamp
  readonly startDate: number;
  // timestamp
  readonly endDate: number;
  readonly street: string;
  readonly zip: string;
  readonly city: string;
  readonly link?: string;
  readonly infoText?: string;
}

export function CockpitContractWidget(props: Props) {
  const { t } = useTranslate();

  const startDate = new Date(props.startDate);
  const endDate = new Date(props.endDate);

  return (
    <WrapperWidget>
      <div className="flex flex-col h-full gap-y-6">
        <div className="flex flex-row gap-x-2 gap-y-2">
          <h2 className="text-lg font-bold flex-shrink-0">
            {t('cockpit_contract_widget_title')}
          </h2>
        </div>

        {(props.street || props.zip || props.city) && (
          <div>
            <h3 className="font-bold">
              {t('cockpit_contract_widget_address')}
            </h3>
            {props.street && (
              <>
                {props.street}
                {(props.zip || props.city) && <br />}
              </>
            )}
            {props.zip && props.zip}
            {props.zip && props.city && ' '}
            {props.city && props.city}
          </div>
        )}

        <div>
          <h3 className="font-bold">{t('cockpit_contract_widget_duration')}</h3>
          {formatDate(startDate)} - {formatDate(endDate)}
        </div>

        {props.contractUrl ? (
          <div>
            <h3 className="font-bold">
              {t('cockpit_contract_widget_download_title')}
            </h3>
            <AppLink
              to={props.contractUrl}
              className="text-primary-500 hover:underline"
            >
              {t('cockpit_contract_widget_page_button_text')}
            </AppLink>
          </div>
        ) : null}

        {props.link ? (
          <AppLink
            to={props.link}
            className="self-start"
          >
            <Button
              primary
              showArrow
            >
              {t('cockpit_contract_widget_button_text')}
            </Button>
          </AppLink>
        ) : null}
      </div>
    </WrapperWidget>
  );
}
